<template>
  <div :class="$style.record">
    <h1>
      <img :src="`${$cdnUrl}/tgStore/xiangzuo.png`" alt="" @click="$router.go(-1)">
      <span>购买记录</span>
    </h1>
    <div :class="$style.userInfo">
      <p>
        账号：<span>{{ userInfo.account }}</span>
      </p>
      <p>
        区服：<span>{{ userInfo.server }}</span> 角色：<span>{{ userInfo.role }}</span>
      </p>
    </div>
    <ul>
      <li :class="$style.tr"><span>商品名称</span><span>购买价格</span><span :class="$style.time">购买时间</span></li>
      <li v-for="(item, index) in recordList" :key="index" :class="$style.content">
        <span :class="$style.orange">{{ item.shop_good_name }}</span>
        <span>{{ item.actual_pay }}元</span>
        <span :class="$style.time">{{ item.pay_time }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { purchaseList, shopData } from '@/api/tgStore';

export default {
  name: '',
  data() {
    return {
      recordList: [
      ],
    };
  },
  mounted() {
    if (!this.userInfo.account) this.$router.push({ name: 'tgStore.store', query: { config_id: this.$route.query.config_id , origin_id: this.$route.query.origin_id} });
    shopData({type: 6, config_id: this.$route.query.origin_id})
    this.getRecord()
  },
  computed: {
    ...mapState({
      userInfo: state => state.tgStore.userInfo
    })
  },
  methods: {
    async getRecord() {
      const r = await purchaseList({ config_id: this.$route.query.config_id });
      this.recordList = r.data.data
    }
  }
};
</script>

<style lang="scss" module>
.record {
  > h1 {
     background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
    padding: 10px 0;
    font-size: 18px;
    border-bottom: 1px solid #F6F6F6;
    margin-bottom: 10px;
    > img {
      position: absolute;
      left: 10px;
      width: 8px;
      height: 15px; 
    }
  }
  .userInfo {
    padding: 8px 20px;
    font-size: 13px;
    color: #333333;
    line-height: 20px;
    border-bottom: 1px solid #F6F6F6;
    > p {
      > span {
        color: #BBBBBB;
        margin-right: 20px;
      }
    }
  }
  > ul {
    padding: 0 20px;
    > li {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      line-height: 34px;
      text-align: center;
      border-bottom: 1px solid #F6F6F6;
      &.tr {
        font-size: 13px;
      }
      > span {
        width: 29%;
      }
      .time {
        width: 42%;
      }
    }
    .content {
      color: #999999;
    }
    .orange {
      color: #FF7A21;
    }
  }
}
</style>
